import * as React from 'react';
import { renderAlert_unstable } from './renderAlert';
import { useAlert_unstable } from './useAlert';
import { useAlertStyles_unstable } from './useAlertStyles.styles';
/**
 * An Alert component displays a brief, important message to attract a user's attention
 *  without interrupting their current task.
 */ export const Alert = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useAlert_unstable(props, ref);
    useAlertStyles_unstable(state);
    return renderAlert_unstable(state);
});
Alert.displayName = 'Alert';
